import MoreVertIcon from "@mui/icons-material/MoreVert";
import { IconButton, Menu, MenuItem, TableCell, TableRow } from "@mui/material";
import { GoalConfigurationTemplateTableItemFragment } from "apps/web/src/types";
import { useState } from "react";

type TableBodyRowsProps = {
    data: GoalConfigurationTemplateTableItemFragment,
    onDelete: () => void;
    onDuplicate: () => void;
    onClick: () => void;
    onViewAssignedAthlete: () => void;
    onAssignGoal: () => void;
}

export const TableBodyRows = ({ data, onDelete, onDuplicate, onClick, onViewAssignedAthlete, onAssignGoal }: TableBodyRowsProps) => {
    const [moreAnchorEl, setMoreAnchorEl] = useState<HTMLElement | null>(null);

    return (
        <>
            <TableRow hover onClick={onClick} sx={{ cursor: "pointer", height: 48 }}>
                <TableCell>{data.category.defaultEmoji}</TableCell>
                <TableCell>{data.name}</TableCell>
                <TableCell>{data.category.name}</TableCell>
                <TableCell>{data.target?.id ? "Update progress" : "Mark as complete"}</TableCell>
                <TableCell>{data.createdBy.firstName + " " + data.createdBy.lastName}</TableCell>
                <TableCell>{data.assignedAthleteCount}</TableCell>
                <TableCell padding="checkbox" align="center">
                    <IconButton
                        onClick={e => {
                            e.stopPropagation();
                            setMoreAnchorEl(e.currentTarget);
                        }}
                        size="large"
                    >
                        <MoreVertIcon />
                    </IconButton>
                </TableCell>
            </TableRow>
            <Menu
                anchorEl={moreAnchorEl}
                open={Boolean(moreAnchorEl)}
                onClose={() => setMoreAnchorEl(null)}
                keepMounted
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem
                    dense
                    onClick={() => {
                        setMoreAnchorEl(null);
                        onAssignGoal();
                    }}
                >
                    Assign goal
                </MenuItem>
                <MenuItem
                    dense
                    onClick={() => {
                        setMoreAnchorEl(null);
                        onViewAssignedAthlete();
                    }}
                >
                    View assigned athletes
                </MenuItem>
                <MenuItem
                    dense
                    onClick={() => {
                        setMoreAnchorEl(null);
                        onDuplicate();
                    }}
                >
                    Duplicate
                </MenuItem>
                <MenuItem
                    dense
                    onClick={() => {
                        setMoreAnchorEl(null);
                        onDelete();
                    }}
                >
                    Delete
                </MenuItem>
            </Menu>
        </>
    );
};
